export default {
      id: "i-arrow-right-new-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right-new",
      toString: function () {
        return this.url;
      }
    }